import styled from "styled-components"
import { Form } from '@unform/web';


export const ModalForm = styled(Form)`
    display:flex;
    flex-flow:column;

    .MuiFormControl-root {
        margin: 3px 0;
    }


    .MuiFormHelperText-root, .MuiFormHelperText-root.Mui-error{
        margin-top:0;
    }
   
`
